/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Reason_Creditpurchase1Inputs */

const zh_usage_reason_creditpurchase1 = /** @type {(inputs: Usage_Reason_Creditpurchase1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分包购买`)
};

const en_usage_reason_creditpurchase1 = /** @type {(inputs: Usage_Reason_Creditpurchase1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit pack purchase`)
};

const es_usage_reason_creditpurchase1 = /** @type {(inputs: Usage_Reason_Creditpurchase1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra de paquete de créditos`)
};

/**
* | output |
* | --- |
* | "Credit pack purchase" |
*
* @param {Usage_Reason_Creditpurchase1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usage_reason_creditpurchase1 = /** @type {((inputs?: Usage_Reason_Creditpurchase1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Reason_Creditpurchase1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_reason_creditpurchase1(inputs)
	if (locale === "en") return en_usage_reason_creditpurchase1(inputs)
	return es_usage_reason_creditpurchase1(inputs)
});
export { usage_reason_creditpurchase1 as "usage_reason_creditPurchase" }